








































































































































































import { Component, Inject, Mixins } from "vue-property-decorator";
import { RegexMatch } from "@/data/enums/router";
import { QUERY_PARAMS } from "@/data/constants";
import {
  IClientProviderData,
  IClientProviderMethods
} from "@/models/providers/client";
import ClientMixin from "@/mixins/clientMixin";
import { DataModules } from "@/store/modules/data";
import { IInvoice } from "@/models/invoices";

@Component({
  components: {
    "fraud-status": () =>
      import("@/components/app/global/fraud/fraudStatus.vue"),
    "client-tags": () => import("@/components/app/global/client/clientTags.vue")
  }
})
export default class ClientProfileCard extends Mixins(ClientMixin) {
  // Inject

  @Inject({ from: "clientProvider" })
  public readonly $clientProvider!: () => IClientProviderData;

  @Inject({ from: "clientMethods" })
  public readonly $clientMethods!: IClientProviderMethods;

  // Computed

  public get $clientData() {
    return this.$clientProvider();
  }

  public get adminOrderRoute() {
    return {
      name: "adminOrderShop",
      params: { basketId: RegexMatch.NEW },
      query: {
        [QUERY_PARAMS.CLIENT_ID]: this.$clientData.clientId,
        [QUERY_PARAMS.ACCOUNT_ID]: this.$clientData.accountId
      }
    };
  }

  // Methods

  public openNewTicketModal() {
    this.$store.dispatch(
      "data/tickets/openNewTicketModal",
      this.$_.pick(this.$clientData, ["clientId", "accountId", "brandId"])
    );
  }

  public placeNewQuickOrder() {
    this.$store.dispatch(`data/${DataModules.BASKETS}/openQuickOrderModal`, {
      props: {
        clientId: this.$clientData.clientId,
        accountId: this.$clientData.accountId
      },
      events: {
        success: (invoice: IInvoice) => {
          this.$router.push({
            name: "adminInvoice",
            params: {
              clientId: this.$clientData.clientId,
              invoiceId: invoice.id
            }
          });
        }
      }
    });
  }
}
